import React from 'react'
import { Box, Eye, GraduationCap, CheckCircle, Activity, Shield, Cloud, Settings, Users, Zap, ChevronRight, Menu, X, Award, Lock, Globe } from 'lucide-react';

const EnterprisePlatform = () => {
  return (
        <section id="enterprise-platform" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">Enterprise-Grade Platform</h2>
            <p className="text-xl text-gray-600">Built for security, scalability, and customization</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-yellow-50 to-white rounded-2xl p-8 border-2 border-yellow-400/30 shadow-lg">
              <Shield className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold text-black mb-3">Secure & Compliant</h3>
              <p className="text-gray-600 mb-4">AWS-hosted with enterprise security standards</p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• OAuth authentication</li>
                <li>• IP blocking</li>
                <li>• Data encryption</li>
                <li>• Role-based access</li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-white rounded-2xl p-8 border-2 border-yellow-400/30 shadow-lg">
              <Settings className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold text-black mb-3">Fully Customizable</h3>
              <p className="text-gray-600 mb-4">Tailor every aspect to your brand and needs</p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Custom branding</li>
                <li>• Authoring tools</li>
                <li>• Content management</li>
                <li>• Flexible workflows</li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-white rounded-2xl p-8 border-2 border-yellow-400/30 shadow-lg">
              <Users className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold text-black mb-3">Guided Onboarding</h3>
              <p className="text-gray-600 mb-4">We handle setup and hand over ready-to-use</p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Custom content creation</li>
                <li>• User training</li>
                <li>• Technical support</li>
                <li>• Ongoing assistance</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
  )
}

export default EnterprisePlatform